import {
  Button,
  Container,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import ParcelInputs from './parcelInputs';
import PaymentInputs from './paymentInputs';
import { useShipping } from './shippingProvider';

export default function ParcelForm({ onNext, onPrev, packagesInfo = [] }) {
  const {
    isParcelValid,
    setParcelValidity,
    parcelValues, setParcelValues,
    shippingPayment, setShippingPayment,
    handleGetRates,
    handleClearRates,
    isLoading,
  } = useShipping();

  const [isPaymentValid, setIsPaymentValid] = useState();

  const handlePrev = () => {
    handleClearRates();
    onPrev();
  };

  return (
    <SpaceBetween size="m">
      {parcelValues.map((parcel, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Container key={index} header={<Header>{`Package ${index + 1} Parcel Information`}</Header>}>
          <ParcelInputs
            defaultValues={parcel}
            onChange={(values, valid) => {
              if (valid) {
                setParcelValues((prev) => {
                  if (
                    prev[index]?.length === values.length
                    && prev[index]?.width === values.width
                    && prev[index]?.height === values.height
                    && prev[index]?.weight === values.weight
                  ) {
                    return prev; // no change
                  }
                  const newValues = [...prev];
                  newValues[index] = values;
                  return newValues;
                });
              }
              setParcelValidity((prev) => {
                const newValidity = [...prev];
                newValidity[index] = valid;
                return newValidity;
              });
            }}
          />
        </Container>
      ))}

      <Container header={<Header>Shipping Payment</Header>}>
        <PaymentInputs
          defaultValues={shippingPayment || {}}
          onChange={(values, valid) => {
            setIsPaymentValid(valid);
            if (valid) {
              setShippingPayment(values);
            }
          }}
        />
      </Container>

      <div style={{ display: 'flex', gap: 16, justifyContent: 'flex-end' }}>
        <Button onClick={handlePrev}>Back</Button>
        <Button variant="primary" disabled={!isParcelValid || !isPaymentValid} loading={isLoading} onClick={() => handleGetRates({ onSuccess: onNext, packagesInfo })}>Next</Button>
      </div>
    </SpaceBetween>
  );
}

ParcelForm.propTypes = {
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  packagesInfo: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    quantityShipped: PropTypes.number,
  })),
};
